import type { ExploreContentItemContentOneOfFivezeroAuth } from './exploreContentItemContentOneOfFivezeroAuth';
import type { ExploreContentItemContentOneOfFivezeroBasicInfo } from './exploreContentItemContentOneOfFivezeroBasicInfo';
import type { ExploreContentItemContentOneOfFivezeroContent } from './exploreContentItemContentOneOfFivezeroContent';
import type { ExploreContentItemContentOneOfFivezeroMedia } from './exploreContentItemContentOneOfFivezeroMedia';
import type { ExploreContentItemContentOneOfFivezeroSource } from './exploreContentItemContentOneOfFivezeroSource';

export type ExploreContentItemContentOneOfFivezero = {
  /** 인증 컨텍스트 정보 */
  auth?: ExploreContentItemContentOneOfFivezeroAuth;
  basicInfo?: ExploreContentItemContentOneOfFivezeroBasicInfo;
  /** 뉴스 내용 정보 */
  content?: ExploreContentItemContentOneOfFivezeroContent;
  /** 미디어 정보 */
  media?: ExploreContentItemContentOneOfFivezeroMedia;
  /** 뉴스 출처 정보 */
  source?: ExploreContentItemContentOneOfFivezeroSource;
};
